import { PageTitle } from '@/shared/ui/text/page-title';
import { SettingsColumn } from '@/widgets/settings/settings-column';
import { SettingsSection } from '@/widgets/settings/settings-section';

import { SecurityDeleteAccountRow } from './security-page/security-delete-account-row';
import { SecurityPasswordRow } from './security-page/security-password-row';

export function SecurityPage() {
    return (
        <SettingsColumn className="space-y-8">
            <PageTitle>Security</PageTitle>

            <SettingsSection title="Login" className="mb-12">
                <SecurityPasswordRow />
            </SettingsSection>

            <SettingsSection title="Account">
                <SecurityDeleteAccountRow />
            </SettingsSection>
        </SettingsColumn>
    );
}
